function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#007AFF",
  strokeWidth: 1.548
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M9.474 0L9.474 14.118",
  transform: "translate(-180 -598) translate(180 599)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.823 0L9.474 3.328",
  transform: "translate(-180 -598) translate(180 599) matrix(-1 0 0 1 22.297 0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.474 0L6.124 3.328",
  transform: "translate(-180 -598) translate(180 599)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.167 6.833v16.452H.833V6.833h16.334z",
  transform: "translate(-180 -598) translate(180 599) rotate(90 9 15.059)"
}))));

var SvgIcShare = function SvgIcShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-share.604bcd76.svg";
export { ForwardRef as ReactComponent };